import barba from '@barba/core';
import { gsap } from "gsap";
import aos from './utils/aos'
import lazyImgs from './utils/lazyImgs'
import Vue from 'vue';

barba.hooks.beforeEnter(({ next }) => {
	aos(next.container)
	lazyImgs(next.container)
	
	// assign all hero imagery to nav menu:
	const navHeros = document.querySelectorAll('.nav-image')
	const navLinks = document.querySelectorAll('.nav-item.parent')

	navLinks.forEach((link, i) => {
		const heroSrc = link.dataset.navhero
		if (typeof(heroSrc) !== "undefined" && heroSrc !== 'false') {
			link.addEventListener('click', function(e) {
				console.log("clicked! - source is:", heroSrc)
				navHeros.forEach((hero, i) => {
					hero.style.backgroundImage = `url('${heroSrc}')`;
				})
			})
		}
	})

})

barba.hooks.afterEnter(({ next }) => {
	// after enter hook stuff
})

barba.hooks.beforeLeave(({ next }) => {
	// before leave hook stuff
	window.scrollTo(0,0)

	// close all open UI etc:
	window.dispatchEvent(new CustomEvent('closeall'))
})

// import all transitions in the barba transitions folder
const transitions = []
const t = require.context('./transitions/', false, /\.js$/)
t.keys().forEach(key => transitions.push(t(key).default))

// import all views in the barba views folder
const views = []
const v = require.context('./views/', false, /\.js$/)
v.keys().forEach(key => views.push(v(key).default))

// initialise Barba.js
barba.init({
	transitions,
	views,
	timeout: 5000,
	debug: true
})
